import { render } from "./Complaint.vue?vue&type=template&id=35ad6a56&scoped=true"
import script from "./Complaint.vue?vue&type=script&lang=js"
export * from "./Complaint.vue?vue&type=script&lang=js"

import "./Complaint.vue?vue&type=style&index=0&id=35ad6a56&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-35ad6a56"

export default script